module.exports = __webpack_public_path__ + "img/00012.8bf03c15.webp";